export const categories = [
  {
    id: 'leafy-greens',
    name: '叶菜类',
    description: '新鲜嫩绿的各类叶菜，富含维生素和膳食纤维，每日新鲜采摘',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20green%20leafy%20vegetables%20like%20spinach%20bok%20choy%20and%20lettuce%20arranged%20on%20a%20rustic%20wooden%20table%20with%20soft%20natural%20morning%20light%20streaming%20through%20a%20window%2C%20clean%20minimalist%20composition%2C%20white%20background%2C%20editorial%20food%20photography%20with%20dew%20drops%20on%20leaves&width=800&height=600&seq=cat-leafy-01&orientation=landscape',
    productCount: 28,
  },
  {
    id: 'root-vegetables',
    name: '根茎类',
    description: '营养丰富的根茎蔬菜，口感扎实，适合煲汤炖煮，农家自种品质',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20root%20vegetables%20including%20carrots%20potatoes%20radishes%20and%20sweet%20potatoes%20displayed%20on%20a%20wooden%20surface%20with%20warm%20natural%20lighting%2C%20earthy%20tones%2C%20clean%20white%20background%2C%20professional%20food%20photography%20style&width=800&height=600&seq=cat-root-01&orientation=landscape',
    productCount: 22,
  },
  {
    id: 'fruit-vegetables',
    name: '茄果类',
    description: '饱满多汁的茄果蔬菜，自然成熟不催熟，保留最纯正的天然风味',
    icon: 'ri-seedling-line',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20tomatoes%20eggplants%20bell%20peppers%20and%20cucumbers%20arranged%20artistically%20on%20a%20light%20wooden%20table%2C%20bright%20natural%20sunlight%2C%20clean%20minimal%20background%2C%20vibrant%20colors%2C%20editorial%20food%20photography&width=800&height=600&seq=cat-fruit-01&orientation=landscape',
    productCount: 18,
  },
  {
    id: 'mushrooms',
    name: '菌菇类',
    description: '多种新鲜菌菇，来自专业菌菇培育基地，口感鲜美营养丰富',
    icon: 'ri-bug-line',
    image: 'https://readdy.ai/api/search-image?query=Various%20fresh%20mushrooms%20including%20shiitake%20enoki%20and%20oyster%20mushrooms%20displayed%20on%20a%20wooden%20board%2C%20soft%20diffused%20natural%20light%2C%20neutral%20white%20background%2C%20clean%20professional%20food%20photography&width=800&height=600&seq=cat-mush-01&orientation=landscape',
    productCount: 15,
  },
  {
    id: 'beans',
    name: '豆类',
    description: '新鲜采摘的各类豆类蔬菜，颗粒饱满，口感清甜，当日直供',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20green%20beans%20peas%20and%20snow%20peas%20arranged%20on%20a%20white%20ceramic%20plate%20on%20a%20wooden%20table%2C%20bright%20natural%20light%2C%20clean%20minimal%20background%2C%20professional%20food%20photography&width=800&height=600&seq=cat-beans-01&orientation=landscape',
    productCount: 12,
  },
  {
    id: 'melons',
    name: '瓜类',
    description: '当季新鲜瓜类，水分充足口感脆嫩，从产地直发保证新鲜度',
    icon: 'ri-plant-line',
    image: 'https://readdy.ai/api/search-image?query=Seasonal%20fresh%20melons%20pumpkins%20zucchini%20and%20cucumbers%20arranged%20on%20a%20rustic%20wooden%20surface%2C%20warm%20natural%20sunlight%2C%20clean%20white%20background%2C%20editorial%20food%20photography&width=800&height=600&seq=cat-melon-01&orientation=landscape',
    productCount: 10,
  },
];

export const products = [
  {
    id: 'prod-01',
    categoryId: 'leafy-greens',
    name: '有机菠菜',
    subtitle: '产地直供 · 当日采摘',
    price: 12.8,
    unit: '500g',
    origin: '山东寿光',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20organic%20spinach%20leaves%20with%20dew%20drops%20in%20a%20bamboo%20basket%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20vibrant%20green%20color&width=600&height=600&seq=prod-spinach-01&orientation=squarish',
    tags: ['有机', '热卖'],
    isNew: false,
    isHot: true,
  },
  {
    id: 'prod-02',
    categoryId: 'leafy-greens',
    name: '上海青',
    subtitle: '本地种植 · 清晨采摘',
    price: 6.8,
    unit: '500g',
    origin: '上海崇明',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20Shanghai%20bok%20choy%20green%20vegetables%20in%20a%20woven%20basket%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20crisp%20vibrant%20green&width=600&height=600&seq=prod-bokchoy-01&orientation=squarish',
    tags: ['本地', '新鲜'],
    isNew: true,
    isHot: false,
  },
  {
    id: 'prod-03',
    categoryId: 'leafy-greens',
    name: '生菜',
    subtitle: '水培种植 · 无农药残留',
    price: 8.5,
    unit: '500g',
    origin: '北京大兴',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20crisp%20green%20lettuce%20head%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20studio%20lighting%2C%20vibrant%20fresh%20appearance&width=600&height=600&seq=prod-lettuce-01&orientation=squarish',
    tags: ['水培', '无农药'],
    isNew: false,
    isHot: false,
  },
  {
    id: 'prod-04',
    categoryId: 'root-vegetables',
    name: '有机胡萝卜',
    subtitle: '沙地种植 · 甜脆可口',
    price: 9.9,
    unit: '500g',
    origin: '河北张家口',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20organic%20orange%20carrots%20with%20green%20tops%20in%20a%20wooden%20crate%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting&width=600&height=600&seq=prod-carrot-01&orientation=squarish',
    tags: ['有机', '沙地'],
    isNew: false,
    isHot: true,
  },
  {
    id: 'prod-05',
    categoryId: 'root-vegetables',
    name: '新鲜土豆',
    subtitle: '黄土高原 · 粉糯香甜',
    price: 5.8,
    unit: '1000g',
    origin: '陕西榆林',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20brown%20potatoes%20in%20a%20rustic%20wooden%20bowl%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20earthy%20texture&width=600&height=600&seq=prod-potato-01&orientation=squarish',
    tags: ['粉糯', '百搭'],
    isNew: false,
    isHot: false,
  },
  {
    id: 'prod-06',
    categoryId: 'root-vegetables',
    name: '铁棍山药',
    subtitle: '河南焦作 · 药食同源',
    price: 18.8,
    unit: '500g',
    origin: '河南焦作',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20Chinese%20yam%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20natural%20earthy%20texture&width=600&height=600&seq=prod-yam-01&orientation=squarish',
    tags: ['药食同源', '滋补'],
    isNew: true,
    isHot: false,
  },
  {
    id: 'prod-07',
    categoryId: 'fruit-vegetables',
    name: '普罗旺斯西红柿',
    subtitle: '沙瓤多汁 · 儿时味道',
    price: 15.8,
    unit: '500g',
    origin: '山东寿光',
    image: 'https://readdy.ai/api/search-image?query=Ripe%20red%20tomatoes%20in%20a%20wooden%20crate%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20vibrant%20red%20color&width=600&height=600&seq=prod-tomato-01&orientation=squarish',
    tags: ['沙瓤', '爆汁'],
    isNew: false,
    isHot: true,
  },
  {
    id: 'prod-08',
    categoryId: 'fruit-vegetables',
    name: '水果黄瓜',
    subtitle: '无刺脆甜 · 可生食',
    price: 8.8,
    unit: '500g',
    origin: '山东潍坊',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20green%20cucumbers%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20crisp%20fresh%20appearance&width=600&height=600&seq=prod-cucumber-01&orientation=squarish',
    tags: ['无刺', '生食'],
    isNew: false,
    isHot: false,
  },
  {
    id: 'prod-09',
    categoryId: 'mushrooms',
    name: '鲜香菇',
    subtitle: '菌菇基地 · 当日采摘',
    price: 14.8,
    unit: '300g',
    origin: '浙江庆元',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20shiitake%20mushrooms%20in%20a%20bamboo%20basket%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20earthy%20brown%20texture&width=600&height=600&seq=prod-shitake-01&orientation=squarish',
    tags: ['基地直供', '鲜美'],
    isNew: false,
    isHot: true,
  },
  {
    id: 'prod-10',
    categoryId: 'mushrooms',
    name: '金针菇',
    subtitle: '洁白鲜嫩 · 火锅必备',
    price: 5.8,
    unit: '300g',
    origin: '江苏徐州',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20white%20enoki%20mushrooms%20in%20a%20clean%20package%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting&width=600&height=600&seq=prod-enoki-01&orientation=squarish',
    tags: ['火锅', '鲜嫩'],
    isNew: false,
    isHot: false,
  },
  {
    id: 'prod-11',
    categoryId: 'beans',
    name: '荷兰豆',
    subtitle: '脆嫩清甜 · 当日直供',
    price: 11.8,
    unit: '300g',
    origin: '云南昆明',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20green%20snow%20peas%20in%20a%20wooden%20bowl%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting&width=600&height=600&seq=prod-snowpea-01&orientation=squarish',
    tags: ['脆嫩', '清甜'],
    isNew: true,
    isHot: false,
  },
  {
    id: 'prod-12',
    categoryId: 'melons',
    name: '贝贝南瓜',
    subtitle: '粉糯香甜 · 宝宝辅食优选',
    price: 12.8,
    unit: '个（约500g）',
    origin: '山东潍坊',
    image: 'https://readdy.ai/api/search-image?query=Small%20green%20kabocha%20pumpkin%20on%20white%20background%2C%20clean%20minimal%20product%20photography%2C%20bright%20natural%20lighting%2C%20natural%20texture&width=600&height=600&seq=prod-pumpkin-01&orientation=squarish',
    tags: ['粉糯', '辅食'],
    isNew: false,
    isHot: true,
  },
];